// This JavaScript file is created by Cision for our media feed.
// This is the first version of this file so far.
// This should be combined with media-listing.html

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};
cision.websolution.settings = cision.websolution.settings || {};
cision.websolution.formatHelpers = cision.websolution.formatHelpers || {};

cision.websolution.mediafeed = !cision.websolution.settings.mediafeed ? {} : function ($) {

    var settings = $.extend({}, cision.websolution.settings.general),
        accessKey = cision.websolution.settings.mediafeed.accessKey,
        texts = cision.websolution.texts[settings.uiLanguage];

    function generateUrl(path) {
        var url = settings.useProxyHandler
            ? settings.proxyHandler + '?url=' + settings.serviceEndpoint + path
            : settings.serviceEndpoint + path;

        return url;
    }

    var renderListing = function (options) {
        if (options) {
            $.extend(settings, options);
            if (options.accessKey) {
                accessKey = options.accessKey;
            }
        }

        if (!accessKey) {
            console.log("You must provide your mediafeed access key.");
            return;
        }
        var url = generateUrl('NewsRoom/' + accessKey + '/Medias');

        var d = $.Deferred();
        $.ajax({
            url: url,
                type: 'GET',
                dataType: 'json',
                data: {
                    mediaRestriction: settings.mediaRestriction,
                    startDate: settings.startDate,
                    endDate: settings.endDate,
                    pageIndex: settings.pageIndex,
                    pageSize: settings.pageSize,
                    tags: settings.tags
                }
            })
            .done(function (objResponse) {
                var mediaList = { Images: [], Videos: [], Embedded: [], Medias: [] };
                $.each(objResponse.Medias, function (idx, objMedia) {
                    objMedia.CreateDate = moment(objMedia.CreateDate).locale(settings.uiLanguage).format(settings.dateFormat);
                    objMedia.ThumbnailUrlImage = objMedia.UrlTo200x200ArResized || objMedia.UrlTo200x200Thumbnail;
                    objMedia.DownloadUrl = objMedia.LargeThumbnailUrl || objMedia.DownloadUrl;

                    if (objMedia.MediaType === "Image") {
                        mediaList.Images.push(objMedia);
                    }
                    if (objMedia.MediaType === "Embedded") {
                        objMedia.EmbeddedItem = objMedia.EmbedCode;
                        mediaList.Embedded.push(objMedia);
                    }
                    if (objMedia.MediaType === "Video") {
                        mediaList.Videos.push(objMedia);
                    }

                    mediaList.Medias.push(objMedia);
                });

                mediaList.PageIndex = objResponse.PageIndex;
                mediaList.PageSize = objResponse.PageSize;
                mediaList.PreviousPageExists = objResponse.PageIndex > 0;
                mediaList.PreviousPageIndex = Math.max(1, objResponse.PageIndex - 1);
                mediaList.NextPageIndex = objResponse.PageIndex + 1;
                mediaList.NextPageExists = (objResponse.PageIndex * objResponse.PageSize) < objResponse.TotalFound;
                mediaList.PageCount = Math.ceil(objResponse.TotalFound / objResponse.PageSize);

                mediaList.Images = mediaList.Images.reverse();
                mediaList.Medias = mediaList.Medias.reverse();
                mediaList.Videos = mediaList.Videos.reverse();
                mediaList.Embedded = mediaList.Embedded.reverse();

                $.extend(mediaList, texts, settings);

                var renderedHtml = $("#tplMediaList").render(mediaList, cision.websolution.formatHelpers);
                $("#target-media-list").html(renderedHtml);

                d.resolve();
            })
            .fail(function() {
                console.log('Could not retrieve data');
                d.reject();
            });

        return d.promise();
    };

    var renderThumbnails = function (options) {
        if (options) {
            $.extend(settings, options);
            if (options.accessKey) {
                accessKey = options.accessKey;
            }
        }

        if (!accessKey) {
            console.log("You must provide your newsfeed access key.");
            return;
        }
        var url = generateUrl('NewsRoom/' + accessKey + '/Medias');

        var d = $.Deferred();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                mediaRestriction: 'image',
                startDate: settings.startDate,
                endDate: settings.endDate,
                pageIndex: settings.pageIndex,
                pageSize: settings.pageSize
            }
        })
            .done(function (objResponse) {
                var imagesList = { Images: [] };
                $.each(objResponse.Medias, function (idx, objMedia) {
                    if (objMedia.MediaType === "Image") {
                        objMedia.CreateDate = moment(objMedia.CreateDate).locale(settings.uiLanguage).format(settings.dateFormat);
                        objMedia.ThumbnailUrl = objMedia.UrlTo200x200ArResized || objMedia.ThumbnailUrl;
                        imagesList.Images.push(objMedia);
                    }
                });

                imagesList.PageIndex = objResponse.PageIndex;
                imagesList.PageSize = objResponse.PageSize;

                imagesList.Images = imagesList.Images.reverse();

                var compositeModel = $.extend({}, imagesList, texts, settings);

                var renderedHtml = $("#tplThumbnailList").render(compositeModel, cision.websolution.formatHelpers);
                $("#target-thumbnail").html(renderedHtml);

                d.resolve();
            })
            .fail(function () {
                console.log('Could not retrieve data');
                d.reject();
            });
        return d.promise();
    };

    var renderTags = function (options) {
        if (options) {
            settings.showNumberOfTags = options.showNumberOfTags;
            $.extend(settings, options);

            if (options.accessKey) {
                accessKey = options.accessKey;
            }
        }
        if (!accessKey) {
            console.log("You must provide your newsfeed access key.");
            return;
        }
        var url = generateUrl('Newsroom/' + accessKey + '/Tags');

        var d = $.Deferred();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                mainTypes: 'Media'
                }
            })
            .done(function (objResponse) {
                var tagList = [];

                $.each(objResponse.Tags, function (idx, objRelease) {
                    tagList.push(objRelease);
                });

                objResponse.Tags = tagList;
                objResponse.numberOfTags = tagList.length;

                var compositeModel = $.extend({}, objResponse, texts, settings);
                var renderedHtml = $("#tplTags").render(compositeModel, cision.websolution.formatHelpers);
                $("#target-tags").html(renderedHtml);
                d.resolve();

            })
            .fail(function () {
                console.log('Could not retrieve tags');
                d.reject();
            });

        return d.promise();
    };

    return {
        renderListing: renderListing,
        renderThumbnails: renderThumbnails,
        renderTags: renderTags
    };
}(jQuery);